import { DataTestId } from '@project-minerva/typings'
import sanitizeHtml from 'sanitize-html'
import './html-renderer.css'
interface HtmlRendererProps extends DataTestId {
  html: string
}

export const HtmlRender = (props: HtmlRendererProps) => {
  const sanitizedHtml = sanitizeHtml(props.html, sanitizeHtmlOptions)

  return (
    <div
      className="html-renderer-content"
      data-testid={props['data-testid']}
      dangerouslySetInnerHTML={{
        __html: sanitizedHtml,
      }}
    />
  )
}

const sanitizeHtmlOptions = {
  allowedTags: [
    'address',
    'article',
    'aside',
    'footer',
    'header',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hgroup',
    'img',
    'main',
    'nav',
    'section',
    'blockquote',
    'dd',
    'div',
    'dl',
    'dt',
    'figcaption',
    'figure',
    'hr',
    'li',
    'main',
    'ol',
    'p',
    'pre',
    'ul',
    'a',
    'abbr',
    'b',
    'bdi',
    'bdo',
    'br',
    'cite',
    'code',
    'data',
    'dfn',
    'em',
    'i',
    'kbd',
    'mark',
    'q',
    'rb',
    'rp',
    'rt',
    'rtc',
    'ruby',
    's',
    'samp',
    'small',
    'span',
    'strong',
    'sub',
    'sup',
    'time',
    'u',
    'var',
    'wbr',
    'caption',
    'col',
    'colgroup',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',

    // MathML
    'math',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mspace',
    'msqrt',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
  ],
  allowedAttributes: {
    img: ['src', 'style'],
    a: ['href'],
    mspace: ['linebreak'],
    ol: ['type'],
    hr: ['style'],
  },
  allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel', 'data'],
}
